// extracted by mini-css-extract-plugin
module.exports = {"AboutLink":"NavigationLink_AboutLink__288cB","NavLink":"NavigationLink_NavLink__2Leu8"};